import React from "react";
import { observer } from "mobx-react";
import { ItemsContainer } from "./Items.styled";
import CallItem from "../../../../components/itemList/CallsItemList";

const arrayCalls = [
  {
    agent: "Agent Name",
    duration: "3m 12s",
    callType: "Marketing",
    disposition: "Interested",
    outCome: "Left Voicemail",
    timestamp: "7:30 AM · 03/13/24",
    callInfo: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  },
  {
    agent: "Agent Name",
    duration: "3m 12s",
    callType: "Marketing",
    disposition: "Interested",
    outCome: "Left Voicemail",
    timestamp: "7:30 AM · 03/13/24",
    callInfo: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  },
  {
    agent: "Agent Name",
    duration: "3m 12s",
    callType: "Marketing",
    disposition: "Interested",
    outCome: "Left Voicemail",
    timestamp: "7:30 AM · 03/13/24",
    callInfo: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  },
  {
    agent: "Agent Name",
    duration: "3m 12s",
    callType: "Marketing",
    disposition: "Interested",
    outCome: "Left Voicemail",
    timestamp: "7:30 AM · 03/13/24",
    callInfo: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  },
  {
    agent: "Agent Name",
    duration: "3m 12s",
    callType: "Marketing",
    disposition: "Interested",
    outCome: "Left Voicemail",
    timestamp: "7:30 AM · 03/13/24",
    callInfo: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  },
]


const Items = observer(() => {
  return (
    <ItemsContainer>
      {arrayCalls.map((call, index) => (
        <CallItem key={index} info={call} />
      ))}
    </ItemsContainer>
  );
});

export default Items; 